{
    "#A": {
        "key": "#A",
        "position": {
            "x": 3,
            "y": -1,
            "z": 1
        },
        "affiliation": "bad",
        "jobKey": "hero/berserker"
    },
    "#B": {
        "key": "#B",
        "position": {
            "x": 2,
            "y": 8,
            "z": 1
        },
        "affiliation": "bad",
        "jobKey": "hero/berserker"
    },
    "#C": {
        "key": "#C",
        "position": {
            "x": 5,
            "y": 8,
            "z": 1
        },
        "affiliation": "bad",
        "jobKey": "hero/archer"
    }
}
